;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"ffe7d5ae51b1192476bd5a6208665b9c05a08190"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "14.2.18";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";globalThis["_sentryAssetPrefix"] = undefined;globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from '@sentry/nextjs'

/**
 * SC-11130: monitoramento de erros do frontend.
 *
 * O Sentry saiu do projeto em fev/2024 (upgrade para o Next 14) e o New Relic
 * em mai/2025, trocado por um `logError` que só fazia `console.error`. Desde
 * então nenhuma exceção de JS saía do navegador: tela branca ou botão que não
 * respondia só chegava pelo suporte. O `api_error` do Mixpanel (SC-10694)
 * cobre falha de API, não erro de código.
 *
 * O DSN é público por natureza (vai no bundle de qualquer jeito), então fica
 * aqui e não depende de variável no deploy.
 */
Sentry.init({
  dsn: 'https://5c1e5ebc04222078b3ea58315dcb9511@o4512211028148224.ingest.us.sentry.io/4512211048202240',
  // `next dev` fica de fora: o local.env também usa stage "staging".
  enabled: process.env.NODE_ENV === 'production',
  environment: process.env.NEXT_PUBLIC_APP_STAGE || 'production',
  // Só erros, sem tracing de performance: não gasta cota com o que não vamos olhar.
  tracesSampleRate: 0,
  // Dado financeiro e de cliente do merchant não sai do navegador. O padrão do
  // SDK coleta cookies, headers, query string e corpo das requisições.
  dataCollection: {
    userInfo: false,
    cookies: false,
    httpHeaders: false,
    httpBodies: [],
    urlQueryParams: false
  },
  ignoreErrors: [
    // Ruído de navegador, não é bug do produto
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Non-Error promise rejection captured',
    // Queda de conexão do cliente já é medida no `api_error` do Mixpanel
    'Network Error'
  ],
  denyUrls: [
    // Erro de extensão do navegador do usuário
    /extensions\//i,
    /^chrome(-extension)?:\/\//i,
    /^moz-extension:\/\//i,
    /^safari(-web)?-extension:\/\//i,
    // Widget de chat do SendPulse: erro do script deles, não do produto
    /livechat\/bundle\.js/i
  ]
})
